import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const GlosaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='GLOSA' htmlFor='input-glosa' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='glosa'>
          {({ field }) => (
            <Form.InputText {...field} id='input-glosa' disabled={fIsSubmitting} isInvalid={iTouched && iError} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(GlosaFormGroup)
